// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTopButton_scrollToTop__Y94TI","visible":"ScrollToTopButton_visible__0LVXz"};